<template>
  <div>
    <Banner :with-bias-banner="true" />
    <AdaptiveContainer :include-promo-banner="true">
      <div class="download-wrapper overflow-hidden bg-white py-20 flex justify-center">
        <div class="w-11/12 sm:w-5/6 md:w-9/12">
          <h1 class="text-black text-2xl font-bold border-b border-gray-500">
            {{ token ? '我的产品清单' : '免费试用版' }}
          </h1>
          <div
            v-for="(pkg, index) in allPackages"
            :key="index"
            class="product-list"
          >
            <div class="pt-8 pb-5">
              <div class="flex">
                <div class="w-16 pt-4 sm:w-24">
                  <img
                    class="DL-fx2-img"
                    :src="pkg.icon"
                  >
                </div>
                <div class="flex-1 flex flex-col px-5">
                  <h4 class="text-2xl font-bold text-black">
                    {{ pkg.pname }}
                  </h4>
                  <!-- <span class="text-black">授权: BIAS FX 2 Elite</span> -->
                  <span class="text-black">版本: {{ getPackageInfo(pkg, 'version') }}</span>
                  <span class="text-black">发布日: {{ getPackageInfo(pkg, 'release') }}</span>
                  <span
                    class="text-black mb-3"
                  ><a
                    v-if="!pkg.CloudDownLink"
                    :href="pkg.history "
                  >更新记录</a></span>
                  <span
                    v-if="!pkg.CloudDownLink"
                    class="text-red-600 text-sm hidden sm:block"
                  >在 BIAS FX 的 ToneCloud 里重新登录账号，即可激活扩展包。</span>
                </div>
                <button
                  v-if="pkg.CloudDownLink"
                  class="hidden sm:block"
                  @click="toCloudDownload(pkg.CloudDownLink)"
                >
                  云盘下载
                </button>
                <button
                  v-else
                  class="hidden sm:block"
                  @click="toggleDownloadWindow(index)"
                >
                  下载
                </button>
              </div>
              <div class="py-3">
                <button
                  v-if="pkg.CloudDownLink"
                  class="block sm:hidden w-full"
                  @click="toCloudDownload(pkg.CloudDownLink)"
                >
                  云盘下载
                </button>
                <button
                  v-else
                  class="block sm:hidden w-full"
                  @click="toggleDownloadWindow(index)"
                >
                  下载
                </button>
              </div>
              <span class="text-red-600 text-sm block sm:hidden">在 BIAS FX 的 ToneCloud 里重新登录账号，即可激活扩展包。</span>
            </div>

            <hr class="border-gray-500">
          </div>
          <p class="text-center text-black text-sm">
            至我们的
            <span class="block"><a
              class="underline text-yellow-600"
              href="https://s3-us-west-2.amazonaws.com/cn.positivegrid.com/requirements/index.html"
            >常见问答</a>中查看更详细的 Mac 及 Windows 系统规格需求</span>
          </p>
        </div>
      </div>
    </AdaptiveContainer>
    <footer-weixin />
    <footer-common />
    <popup-container
      v-if="showDownloadWindow"
      :allow-backdrop-close="true"
      @close="toggleDownloadWindow(null)"
    >
      <div class="h-full flex flex-col">
        <h4 class="text-2xl text-center mb-8">
          {{ allPackages[packageIndex].pname }}
        </h4>
        <form
          class="flex flex-col flex-1"
          method="get"
          :action="downloadURL"
        >
          <div class="flex flex-row flex-1">
            <div class="flex flex-col flex-1 pl-5">
              <div class="flex items-center mb-3">
                <img
                  class="h-8"
                  src="http://assets.positivegrid.com.cn/media/apple_white.png"
                >
                <span class="ml-2 font-bold">MAC OS</span>
              </div>
              <label
                class="my-2 pl-2"
                for="au-ust"
              >
                <input
                  id="au-ust"
                  v-model="downloadURL"
                  type="radio"
                  name="package"
                  :value="allPackages[packageIndex].download.mac_auvst ? allPackages[packageIndex].download.mac_auvst.download_url : ''"
                > <span class="text-base">AU / VST</span>
              </label>
              <label
                class="my-2 pl-2"
                for="pro-tools"
              >
                <input
                  id="pro-tools"
                  v-model="downloadURL"
                  type="radio"
                  name="package"
                  :value="allPackages[packageIndex].download.mac_protools ? allPackages[packageIndex].download.mac_protools.download_url : ''"
                > <span class="text-base">Pro Tools</span>
              </label>
              <label
                class="my-2 pl-2"
                for="standalone"
              >
                <input
                  id="standalone"
                  v-model="downloadURL"
                  type="radio"
                  name="package"
                  :value="allPackages[packageIndex].download.mac_standalone ? allPackages[packageIndex].download.mac_standalone.download_url : ''"
                > <span class="text-base">Standalone</span>
              </label>
            </div>
            <div class="flex flex-col flex-1 pl-5">
              <div class="flex items-center mb-3">
                <img
                  class="h-8"
                  src="http://assets.positivegrid.com.cn/media/win_white.png"
                >
                <span class="ml-2 font-bold">Windows</span>
              </div>
              <label
                class="my-2 pl-2"
                for="64bit"
              >
                <input
                  id="64bit"
                  v-model="downloadURL"
                  type="radio"
                  name="package"
                  :value="allPackages[packageIndex].download.win64 ? allPackages[packageIndex].download.win64.download_url : ''"
                > <span class="text-base">64比特</span>
              </label>
            </div>
          </div>
          <template v-if="downloadURL">
            <div class="mb-5 flex justify-around">
              <span class="text-sm">MD5</span>
              <span class="text-sm">{{ getMD5 }}</span>
              <span class="text-xs inline-block relative bg-gray-300 w-4 h-4 rounded-full">
                <a
                  target="_blank"
                  href="https://s3-us-west-2.amazonaws.com/cn.positivegrid.com/requirements/md5.html"
                  class="text-black absolute text-center inset-0"
                >?</a>
              </span>
            </div>
            <button
              type="submit"
              class="w-full"
            >
              下载
            </button>
          </template>
          <template v-else>
            <span
              class="text-2xl
              text-center"
            >请选择平台</span>
          </template>
        </form>
      </div>
    </popup-container>
  </div>
</template>

<script>
import Banner from '@/components/banner'
import AdaptiveContainer from '@/components/adaptive-container'
import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'
import PopupContainer from '@/components/popup-container'

import axios from 'axios'
import { NEW_API_URL } from '@/urls'
import { mapState } from 'vuex'
import store from '@/store'
import icon from '@/assets/WechatIMG598.png'
export default {
  components: {
    Banner,
    AdaptiveContainer,
    FooterWeixin,
    FooterCommon,
    PopupContainer
  },
  data () {
    return {
      productList: [],
      showDownloadWindow: false,
      allPackages: [],
      fx2Package: {},
      pedalPackage: {},
      downloadURL: '',
      packageIndex: null
    }
  },
  store,
  computed: {
    ...mapState('Auth', {
      token: 'token'
    }),
    getMD5 () {
      if (this.downloadURL) {
        const platforms = this.allPackages[this.packageIndex].download
        const platform = Object.keys(platforms).filter((name) => {
          return platforms[name].download_url === this.downloadURL
        })
        return platforms[platform].checksum
      } else {
        return ''
      }
    }
  },
  watch: {
    showDownloadWindow: function (value) {
      if (!value) {
        // Object.assign(this.$data, this.$options.data.apply(this))
        this.downloadURL = ''
      }
    },
    token: function () {
      this.fetchFX2Packages()
    }
  },
  mounted () {
    this.fetchFX2Packages()
  },
  methods: {
    //   去云盘下载
    toCloudDownload (url) {
      window.open(url)
    },
    toggleDownloadWindow (index) {
      this.showDownloadWindow = !this.showDownloadWindow
      this.packageIndex = index
    },
    getPackageInfo (pkg, targetInfo) {
      const download = pkg.download

      switch (targetInfo) {
        case 'version':
          return download[Object.keys(download)[0]].version.substr(1)
        case 'release': {
          const date = download[Object.keys(download)[0]].release_date
          return date.slice(0, date.indexOf('T'))
        }
        default:
          return ''
      }
    },
    async fetchFX2Packages () {
      try {
        await axios.get(
          `${NEW_API_URL}/v2/packages`,
          {
            headers: {
              'Authorization': `JWT ${this.token || window.localStorage.getItem('PG_TOKEN')}`,
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(res => {
          console.log('Success!!')
          let arr = res.data.concat(
            [{
              help: 'https://help.positivegrid.com/hc/en-us/categories/200821616-BIAS-Pedal',
              history: 'http://help.positivegrid.com/hc/en-us/articles/206258173-BIAS-Pedal-DESKTOP-Update-History',
              icon: icon,
              pname: 'BIAS FX2 联动RIFF固件',
              system: 'http://help.positivegrid.com/hc/en-us/articles/205944426',
              CloudDownLink: 'https://drive.weixin.qq.com/s?k=AOcA-QcwAAkBVCr2Hh',
              download: {
                'mac_protools': {
                  'display_name': 'MacOS ProTools',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_AAX_Plugin_v2_3_4_5549.dmg',
                  'version': ' windows版本',
                  'checksum': 'd397d6b3fc5b8a04c8260933b4b09db0',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'mac_standalone': {
                  'display_name': 'MacOS Standalone',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_Standalone_v2_3_4_5549.dmg',
                  'version': ' windows版本',
                  'checksum': 'edcae16114ac6ab7f2a4ba90b2283c95',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'mac_auvst': {
                  'display_name': 'MacOS AU/VST',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_VST_AU_Plugin_v2_3_4_5549.dmg',
                  'version': ' windows版本',
                  'checksum': 'd23eee0cef33b2e4aaea327f93079798',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'win32': {
                  'display_name': 'Windows All-In-One 32bit',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Windows32bit_v2_3_4_5549.msi',
                  'version': ' windows版本',
                  'checksum': 'afa4c65f20dfc6830dff0436c3741e67',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'win64': {
                  'display_name': 'Windows All-In-One 64bit',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Windows64bit_v2_3_4_5549.msi',
                  'version': ' windows版本',
                  'checksum': 'c6f351b5b44f78d4efd58afa9f7b431f',
                  'release_date': '2021-11-03T09:49:40.423Z'
                }
              }
            }, {
              help: 'https://help.positivegrid.com/hc/en-us/categories/200821616-BIAS-Pedal',
              history: 'http://help.positivegrid.com/hc/en-us/articles/206258173-BIAS-Pedal-DESKTOP-Update-History',
              icon: icon,
              pname: 'BIAS FX2 联动RIFF固件',
              system: 'http://help.positivegrid.com/hc/en-us/articles/205944426',
              CloudDownLink: 'https://drive.weixin.qq.com/s?k=AOcA-QcwAAk1jvv7Lq',
              download: {
                'mac_protools': {
                  'display_name': 'MacOS ProTools',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_AAX_Plugin_v2_3_4_5549.dmg',
                  'version': ' mac版本',
                  'checksum': 'd397d6b3fc5b8a04c8260933b4b09db0',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'mac_standalone': {
                  'display_name': 'MacOS Standalone',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_Standalone_v2_3_4_5549.dmg',
                  'version': ' mac版本',
                  'checksum': 'edcae16114ac6ab7f2a4ba90b2283c95',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'mac_auvst': {
                  'display_name': 'MacOS AU/VST',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_VST_AU_Plugin_v2_3_4_5549.dmg',
                  'version': ' mac版本',
                  'checksum': 'd23eee0cef33b2e4aaea327f93079798',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'win32': {
                  'display_name': 'Windows All-In-One 32bit',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Windows32bit_v2_3_4_5549.msi',
                  'version': ' mac版本',
                  'checksum': 'afa4c65f20dfc6830dff0436c3741e67',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'win64': {
                  'display_name': 'Windows All-In-One 64bit',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Windows64bit_v2_3_4_5549.msi',
                  'version': ' mac版本',
                  'checksum': 'c6f351b5b44f78d4efd58afa9f7b431f',
                  'release_date': '2021-11-03T09:49:40.423Z'
                }
              }
            }, {
              help: 'https://help.positivegrid.com/hc/en-us/categories/200821616-BIAS-Pedal',
              history: 'http://help.positivegrid.com/hc/en-us/articles/206258173-BIAS-Pedal-DESKTOP-Update-History',
              icon: icon,
              pname: 'BIAS FX2 联动RIFF驱动',
              system: 'http://help.positivegrid.com/hc/en-us/articles/205944426',
              CloudDownLink: 'https://drive.weixin.qq.com/s?k=AOcA-QcwAAkvH7Esen',
              download: {
                'mac_protools': {
                  'display_name': 'MacOS ProTools',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_AAX_Plugin_v2_3_4_5549.dmg',
                  'version': ' windows版本（mac不需要）',
                  'checksum': 'd397d6b3fc5b8a04c8260933b4b09db0',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'mac_standalone': {
                  'display_name': 'MacOS Standalone',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_Standalone_v2_3_4_5549.dmg',
                  'version': ' windows版本（mac不需要）',
                  'checksum': 'edcae16114ac6ab7f2a4ba90b2283c95',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'mac_auvst': {
                  'display_name': 'MacOS AU/VST',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Mac_VST_AU_Plugin_v2_3_4_5549.dmg',
                  'version': ' windows版本（mac不需要）',
                  'checksum': 'd23eee0cef33b2e4aaea327f93079798',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'win32': {
                  'display_name': 'Windows All-In-One 32bit',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Windows32bit_v2_3_4_5549.msi',
                  'version': ' windows版本（mac不需要）',
                  'checksum': 'afa4c65f20dfc6830dff0436c3741e67',
                  'release_date': '2021-11-03T09:49:40.423Z'
                },
                'win64': {
                  'display_name': 'Windows All-In-One 64bit',
                  'download_url': 'https://pg-pkg-file.positivegrid.com.cn/BIAS_Pedal_Windows64bit_v2_3_4_5549.msi',
                  'version': ' windows版本（mac不需要）',
                  'checksum': 'c6f351b5b44f78d4efd58afa9f7b431f',
                  'release_date': '2021-11-03T09:49:40.423Z'
                }
              }
            }])
          // 过滤数据
          let arr2 = arr.filter(item => {
            return item.pname !== 'BIAS Pedal'
          })
          this.allPackages = arr2
        }).catch(err => {
          console.error('Fail!!', err)
        })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
a:link, a:visited {
  @apply text-yellow-600;
}
</style>



// WEBPACK FOOTER //
// src/pages/download.vue